<template>
  <a-modal width="600px"
    title="创建任务"
    v-model:visible="visible"
    :confirm-loading="confirmLoading">
    <div class="paragraph-title">
      基本信息
    </div>
    <a-form ref="form"
      :model="form"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }">
      <a-form-item label="任务名称" name="name" required>
        <a-input v-model:value="form.name" placeholder="1~24个字符，可包含大小写字母、数字、中文、下划线" autocomplete="off"/>
      </a-form-item>
      <a-form-item label="说明" name="description">
        <a-textarea v-model:value="form.description" :row="4" />
      </a-form-item>
      <a-form-item label="任务类型" name="taskTypeId" required>
        <a-select
          style="width: 140px"
          v-model:value="form.taskTypeId"
        >
          <a-select-option v-for="item in taskTypes"
            :key="item.id">
            {{ item.chineseInstructions }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="数据集" name="datasetId" required>
        <a-select style="width: 140px" ref="selectRef"
          v-model:value="form.datasetId"
                  @change="handleChange"
        @popupScroll="scrollHandle">
          <a-select-option v-for="item in dataSetList"
            :key="item.id" :addition="item.addition">
            {{ item.chineseInstructions }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="要求完成时间" name="planFinishTime">
        <a-date-picker :show-time="{ format: 'HH:mm:ss' }"
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
          v-model:value="form.planFinishTime"
        />
      </a-form-item>
       <div class="paragraph-title">
        标注策略
      </div>
      <a-form-item label="标注公司" name="excuteCompanyId" required>
        <a-select
          style="width: 140px"
          v-model:value="form.excuteCompanyId"
        >
          <a-select-option v-for="item in companyList"
                           :key="item.id">
            {{ item.name }}
          </a-select-option>
          <!--<a-select-option :key="1">
            公司A
          </a-select-option>
          <a-select-option :key="2">
            公司B
          </a-select-option>-->
        </a-select>
      </a-form-item>
     <!-- <a-form-item label="智能标注">
        <a-switch v-model:checked="form.smart" />
      </a-form-item> -->
    </a-form>
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel">取消</a-button>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">创建</a-button>
    </template>
  </a-modal>
  <div>

  </div>
</template>
<script>
import moment from 'moment'
import { getAllData } from '@/api/dataSet'
import { getCompanyData } from '@/api/company'
import { mapState } from 'vuex'
import { createTask, updateTask } from '@/api/task'
import { getDateTime } from '@/filters'
import store from '@/store'
export default {
  props: {
    dialogType: {
      type: String,
      default: 'add'
    },
    currentItem: {
      type: Object,
      default: () => {}
    },
    dataSetId: {
      type: String,
      default: () => {}
    },
    taskTypes: {
      type: Array,
      default: () => []
    }
  },
  emits: ['refresh-data'],
  data () {
    return {
      visible: false,
      confirmLoading: false,
      dataSetList: [],
      companyList: [],
      form: {
        name: '',
        description: '',
        taskTypeId: '',
        planFinishTime: moment().add(7, 'days').format('YYYY-MM-DD 23:59:59'),
        datasetId: '',
        excuteCompanyId: ''
      },
      addition: '',
      page: {
        pageNum: 1,
        pageSize: 10
      },
      openSelect: false,
      more: false
    }
  },
  computed: {
    ...mapState(['teamList'])
  },
  mounted () {
    this.getCompanyList()
  },
  methods: {
    handleChange (value, item) {
      this.addition = item.addition
      /* if (item.addition === 'more') {
        const num = this.page.pageNum
        this.page.pageNum = num + 1
        this.getDataSetList()
      } else {
        this.$refs.selectRef.blur()
      } */
    },
    // 数据集输入框获取焦点
    focusHandle () {
      this.openSelect = true
    },
    // 数据集失去框获取焦点
    blurHandle () {
      this.openSelect = false
    },
    scrollHandle (e) {
      // console.log(e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight)
      if (e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 10 && this.more) {
        const num = this.page.pageNum
        this.page.pageNum = num + 1
        this.getDataSetList()
      }
    },
    getCompanyList () {
      const params = {}
      params.pageNum = 1
      params.pageSize = 1000
      params.type = 'annotation'
      getCompanyData(params).then(res => {
        this.companyList = res.data.map.data.rows
      })
    },
    async open () {
      this.visible = true
      /* const testRes = await getDataSetByPage({ pageSize: 1 })
      if (testRes.allRow - 0 !== this.dataSetList.length) {
        await getDataSetByPage({ pageSize: 10000 }).then(res => {
          this.dataSetList = res.data.map.data.rows
        })
      } */
      this.$nextTick(() => {
        this.$refs.form.resetFields()
        this.dataSetList = []
        this.getDataSetList()
        if (this.dialogType === 'edit' && this.currentItem) {
          this.form = { ...this.currentItem, planFinishTime: getDateTime(this.currentItem.planFinishTime) }
        } else if (this.dataSetId) {
          this.form.datasetId = this.dataSetId
        }
      })
    },
    getDataSetList () {
      getAllData({ ...this.page, parentId: 'nullValue', field: 'createTime', order: 'desc' }).then(res => {
        const arr = this.dataSetList
        this.dataSetList = arr.concat(res.data.map.data.rows)
        // console.log(this.dataSetList.length, res.data.map.data.total)
        if (this.dataSetList.length < res.data.map.data.total) {
          this.more = true
        } else {
          this.more = false
        }
        /* const obj = {}
        obj.chineseInstructions = '加载更多'
        obj.id = 'more'
        obj.addition = 'more'
        this.dataSetList.push(obj) */
      })
    },
    handleOk () {
      // console.log('form', this.form)
      if (this.form.name) {
        const time = this.form.planFinishTime.substr(0, 10) + 'T' + this.form.planFinishTime.substr(11)
        // const time = '2020-05-12T10:23:29'
        // console.log('time=', time)
        const regexp = /^[\u4e00-\u9fa5A-Za-z0-9_-]{1,24}$/
        if (regexp.test(this.form.name)) {
          if (this.form.taskTypeId) {
            if (this.form.datasetId) {
              if (this.form.excuteCompanyId) {
                const currentRole = store.state.currentRole
                const { teamId, companyId } = currentRole
                if (this.dialogType === 'edit') {
                  updateTask({
                    ...this.form, planFinishTime: time, state: 'origin', createCompanyId: companyId, createTeamId: teamId
                  }).then(res => {
                    this.$message.success('任务已重新分配')
                    this.visible = false
                    this.$emit('refresh-data')
                  })
                } else {
                  createTask({
                    ...this.form, planFinishTime: time, state: 'origin', createCompanyId: companyId, createTeamId: teamId
                  }).then(res => {
                    this.$message.success('任务已创建')
                    this.visible = false
                    this.$emit('refresh-data')
                  })
                }
              } else {
                this.$message.error('请选择标注公司')
              }
            } else {
              this.$message.error('请选择数据集')
            }
          } else {
            this.$message.error('请填写任务类型')
          }
        } else {
          this.$message.error('任务名称格式错误')
        }
      } else {
        this.$message.error('请填写任务名称')
      }
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>
<style lang="less">
.select_he{
  height: 150px;
  overflow-y: auto;
}
</style>
